module.exports = __webpack_public_path__ + "media/images/badges/akt/milestone-1-Active-AKT-cf634dda978666729089438c8f5ac2a7.png";